import Core from '@mediaplatform/sportal365-football-sdk-v2';
import { getOddsSettings } from '@sportal365/smp-widget-utils';
import { ITeamApi, OddFormat, ScopeTypes } from '../types';

export default (sdk: Core): ITeamApi => {
  const getTeam: ITeamApi['getTeam'] = ({
    signal,
    dataTeam,
    dataSeason,
    dataMatchId,
    teamToCompareWith,
    dataOddsDisplay,
    dataOddsBettingId,
    dataOddsMarket,
    dataOddsPreEventOnly = false,
    dataOddsMarketValueType = OddFormat.DECIMAL,
    dataOddsScopeType = ScopeTypes.ALL,
  }) => {
    if (dataTeam && dataSeason) {
      const team = sdk.team({
        teamId: dataTeam,
        seasonId: dataSeason,
      });

      if (!team) return;

      if (teamToCompareWith) {
        team.withTeamToCompare(teamToCompareWith.id, teamToCompareWith.seasonId ?? dataSeason);
      }

      if (dataMatchId) {
        team.withMatch(dataMatchId);
      }

      if (dataOddsDisplay) {
        team.withOdds({
          ...getOddsSettings(dataOddsBettingId, dataOddsMarket, dataOddsMarketValueType, dataOddsPreEventOnly, dataOddsScopeType),
        });
      }

      return team.get({ signal });
    }

    console.warn('You must provide a valid team id and season id.');
  };
  return { getTeam };
};
